export const errorCodes = {
  INCORRECT_LOGIN: 1,
  ENTER_VALID: 2,
  TOO_MANY_ATTEMPTS: 3,
  PASSWORDS_DO_NOT_MATCH: 4,
  FILL_ALL_FIELDS: 5,
  MAX_CHARACTER_LIMIT: 6,
  FIELD_REQUIRED: 7,
  PLEASE_SELECT_OPTION: 8,
  NAME_ALREADY_EXISTS: 9,
  PASSWORD_MUST_BE_DIFFERENT: 11,
  CURRENT_PASSWORD_IS_INCORRECT: 12,
  HEIGHT_WEIGHT_IS_REQUIRED_FIELD: 17,
  ALL_FIELDS_MUST_BE_POPULATED: 19,
  CANNOT_SELECT_PERIOD_MORE_THAN_30_DAYS: 20,
  ACCOUNT_ON_HOLD: 21,
  PLEASE_SAVE_GENERAL_INFO_BEFORE: 23,
  PASSWORD_RESET_REQUIRED: 25,
  PASSWORD_DETECTED_IN_BREACH: 26,
  PASSWORD_NOT_VALID: 27,
  TOKEN_NOT_VALID: 28,
  EMAIL_UNDELIVERABLE: 29,
  EMAIL_NOT_UNIQUE: 30,
  TOO_MANY_REQUESTS: 105,
  NOT_VERIFY: 107,
  ACTION_BLOCKED: 123,
  PHONE_NOT_UNIQUE: 218,
  BIG_VALUE: 201,
  LICENSE_INVALID: 208,
  INVALID_FILE_FORMAT: 209,
  TOO_BIG_FILE_SIZE: 210,
  DUPLICATE_LICENSES: 214,
  DUPLICATE_OPTIONS: 215,
  OVERLAPPING_SCHEDULE: 302,
  CANT_SAVE_PAST_DATE: 303,
  END_BEFORE_START: 304,
  MORE_THAN_24_HOURS_EVENT: 305,
  LICENSE_WITHOUT_ONE_SERVICE_TYPE: 307,
  REPEAT_TIME_AFTER_END: 308,
  INVALID_VISIT_METHOD: 309,
  TREAT_ERROR: 310,
  VISIT_HAS_COMPLETED: 311,
  ICD_CODE_MISSING: 312,
  ONLY_NUMBERS_AND_LETTERS_ALLOWED: 316,
  LOADING_FAILED: 318,
  REDIRECTING_FAILED: 319,
  NOT_VALID_VALUE: 400,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  ALLERGY_NAME_NOT_UNIQUE: 409,
  DEFAULT: 500,
  NO_CONNECTION: 501,
  TIMEOUT: 512,
  ITEM_DOES_NOT_EXIST: 601,
  FORBIDDEN_ACTION: 624,
  INTERNAL_SERVER_ERROR: 500,
}

export const DEFAULT = 500

export function getUserFriendlyErrorMessage(code = DEFAULT, message = '', extra = {}) {
  let errorMessage
  if (!message) {
    switch (code) {
      case errorCodes.TREAT_ERROR:
        errorMessage = 'Error communicating with Treat.'
        break
      case errorCodes.FORBIDDEN_ACTION:
        errorMessage = 'You are not allowed to update this record.'
        break
      case errorCodes.ACCOUNT_ON_HOLD:
        errorMessage = `This account has been put on hold. Please contact support.`
        break
      case errorCodes.ICD_CODE_MISSING:
        errorMessage = 'ICD-10 code is missing.'
        break
      case errorCodes.VISIT_HAS_COMPLETED:
        errorMessage = 'Visit has already been completed or is not available.'
        break
      case errorCodes.ONLY_NUMBERS_AND_LETTERS_ALLOWED:
        errorMessage = 'Only numbers and letters are allowed.'
        break
      case errorCodes.INVALID_VISIT_METHOD:
        errorMessage = `Incorrect visit method type.`
        break
      case errorCodes.REPEAT_TIME_AFTER_END:
        errorMessage = `Date cannot be before End date.`
        break
      case errorCodes.LICENSE_INVALID:
        errorMessage = `Valid input: A-z, 0-9, '.'`
        break
      case errorCodes.LOADING_FAILED:
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        errorMessage = `Loading failed.${extra.please ? ' Please try again later or contact support.' : ''}`
        break
      case errorCodes.REDIRECTING_FAILED:
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        errorMessage = `Redirecting failed.${extra.please ? ' Please try again later or contact support.' : ''}`
        break
      case errorCodes.OVERLAPPING_SCHEDULE:
        errorMessage = `Cannot save overlapping ${extra} block.`
        break
      case errorCodes.INVALID_FILE_FORMAT:
        errorMessage = `Please select file in the correct format: ${extra}.`
        break
      case errorCodes.DUPLICATE_OPTIONS:
        errorMessage = `Duplicate options detected.`
        break
      case errorCodes.NOT_FOUND:
        errorMessage = `${extra} with sent identifier is not found.`
        break
      case errorCodes.DUPLICATE_LICENSES:
        errorMessage = `Duplicate License.`
        break
      case errorCodes.ALLERGY_NAME_NOT_UNIQUE:
        errorMessage = `Same allergy record already exists.`
        break
      case errorCodes.LICENSE_WITHOUT_ONE_SERVICE_TYPE:
        errorMessage = `License requires at least one service type.`
        break
      case errorCodes.CANT_SAVE_PAST_DATE:
        errorMessage = `Cannot save ${extra} that starts in the past.`
        break
      case errorCodes.END_BEFORE_START:
        errorMessage = `Cannot save ${extra} that starts after the end date and time.`
        break
      case errorCodes.MORE_THAN_24_HOURS_EVENT:
        errorMessage = `Cannot save ${extra} block that is longer than 24 hrs.`
        break
      case errorCodes.ENTER_VALID:
        errorMessage = `Please enter a valid ${extra}.`
        break
      case errorCodes.BIG_VALUE:
        errorMessage = `Please input a number lower than ${extra}.`
        break
      case errorCodes.PASSWORDS_DO_NOT_MATCH:
        errorMessage = 'Passwords do not match.'
        break
      case errorCodes.MAX_CHARACTER_LIMIT:
        errorMessage = 'Max character limit exceeded.'
        break
      case errorCodes.FIELD_REQUIRED:
        errorMessage = `${extra} is a required field.`
        break
      case errorCodes.PLEASE_SELECT_OPTION:
        errorMessage = 'Please select an option.'
        break
      case errorCodes.NAME_ALREADY_EXISTS:
        errorMessage = `${extra} with this name already exists. Please enter a unique name.`
        break
      case errorCodes.ITEM_DOES_NOT_EXIST:
        errorMessage = `Requested ${extra} does not exist. Please refresh your screen.`
        break
      case errorCodes.PASSWORD_MUST_BE_DIFFERENT:
        errorMessage = 'New password must be different.'
        break
      case errorCodes.CURRENT_PASSWORD_IS_INCORRECT:
        errorMessage = 'Current password is incorrect.'
        break
      case errorCodes.HEIGHT_WEIGHT_IS_REQUIRED_FIELD:
        errorMessage = `${extra} is required for patients 0-17 years old.`
        break
      case errorCodes.ALL_FIELDS_MUST_BE_POPULATED:
        errorMessage = `All fields in ${extra} must be populated.`
        break
      case errorCodes.CANNOT_SELECT_PERIOD_MORE_THAN_30_DAYS:
        errorMessage = `Cannot select time period longer than 30 days.`
        break
      case errorCodes.PLEASE_SAVE_GENERAL_INFO_BEFORE:
        errorMessage = `Please save General information first and then Account information.`
        break
      case errorCodes.TIMEOUT:
        errorMessage = 'Server Response Timeout. Please try again.'
        break
      case errorCodes.INCORRECT_LOGIN:
        errorMessage = 'You entered an incorrect email or password.'
        break
      case errorCodes.NO_CONNECTION:
        errorMessage = 'No internet connection detected. Please try again.'
        break
      case errorCodes.TOO_MANY_ATTEMPTS:
        errorMessage = 'Too many failed login attempts. Please try again later.'
        break
      case errorCodes.NOT_VERIFY:
        errorMessage = `The email associated with this account has not been verified.`
        break
      case errorCodes.PHONE_NOT_UNIQUE:
        errorMessage = `This number is already associated with a provider.`
        break
      case errorCodes.FILL_ALL_FIELDS:
        errorMessage = 'Please complete all requirements.'
        break
      case errorCodes.NOT_VALID_VALUE:
        errorMessage = `${extra} is null or not valid`
        break
      case errorCodes.FORBIDDEN:
        errorMessage = 'See preconditions'
        break
      case errorCodes.TOO_BIG_FILE_SIZE:
        errorMessage = `Cannot upload file that is bigger than ${extra}.`
        break
      case errorCodes.DEFAULT:
        errorMessage = 'Internal Server Error. Please contact support.'
        break
      case errorCodes.PASSWORD_DETECTED_IN_BREACH:
        errorMessage = 'Your password was detected in a breach. Please change your password.'
        break
      case errorCodes.PASSWORD_RESET_REQUIRED:
        errorMessage = 'Your password is not valid. Please change your password.'
        break
      case errorCodes.PASSWORD_NOT_VALID:
        errorMessage = 'You have entered an invalid password.'
        break
      case errorCodes.TOKEN_NOT_VALID:
        errorMessage = 'Token not valid. Please try again later.'
        break
      case errorCodes.EMAIL_UNDELIVERABLE:
        errorMessage = 'There was an error sending the email.'
        break
      case errorCodes.EMAIL_NOT_UNIQUE:
        errorMessage = 'This email has already been used.'
        break
      case errorCodes.TOO_MANY_REQUESTS:
        errorMessage = 'Too many requests. Please contact support.'
        break
      case errorCodes.ACTION_BLOCKED:
        errorMessage = `There was an error logging in on this device. Please contact support.`
        break
      default:
        errorMessage = 'Internal Server Error. Please contact support.'
    }
  }
  return `${code} - ${message || errorMessage}`
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getAPIErrorMessage(errorCode) {
  const mapping = {
    AccountNotVerified: getUserFriendlyErrorMessage(errorCodes.NOT_VERIFY),
    AccountNotActive: getUserFriendlyErrorMessage(errorCodes.ACCOUNT_ON_HOLD),
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    EmailNotValid: getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'email'),
    PasswordResetRequired: getUserFriendlyErrorMessage(errorCodes.PASSWORD_RESET_REQUIRED),
    PasswordDetectedInBreach: getUserFriendlyErrorMessage(errorCodes.PASSWORD_DETECTED_IN_BREACH),
    TooManyRequests: getUserFriendlyErrorMessage(errorCodes.TOO_MANY_REQUESTS),
    CredentialsNotValid: getUserFriendlyErrorMessage(errorCodes.INCORRECT_LOGIN),
    PasswordNotValid: getUserFriendlyErrorMessage(errorCodes.PASSWORD_NOT_VALID),
    AccountLocked: getUserFriendlyErrorMessage(errorCodes.TOO_MANY_ATTEMPTS),
    TokenNotValid: getUserFriendlyErrorMessage(errorCodes.TOKEN_NOT_VALID),
    EmailUndeliverable: getUserFriendlyErrorMessage(errorCodes.EMAIL_UNDELIVERABLE),
    EmailNotUnique: getUserFriendlyErrorMessage(errorCodes.EMAIL_NOT_UNIQUE),
    InternalServerError: getUserFriendlyErrorMessage(errorCodes.INTERNAL_SERVER_ERROR),
    ActionBlocked: getUserFriendlyErrorMessage(errorCodes.ACTION_BLOCKED),
  }

  // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
  return mapping[errorCode] || getUserFriendlyErrorMessage(errorCodes.INTERNAL_SERVER_ERROR)
}
